"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLiquidityChangeEvents = fetchLiquidityChangeEvents;
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
async function fetchLiquidityChangeEvents(params) {
    const eventTypesSet = new Set();
    if (params.poolNames) {
        params.poolNames.forEach((poolName) => {
            const eventType = maps_js_1.poolInfo[poolName].liquidityChangeEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    else {
        // Iterate over all the values in poolInfo and add each autoCompoundingEventType to the Set
        Object.values(maps_js_1.poolInfo).forEach((info) => {
            const eventType = info.liquidityChangeEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    const eventTypes = Array.from(eventTypesSet);
    const eventsPromises = eventTypes.map(async (eventType) => {
        const events = await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        });
        return events;
    });
    const events = (await Promise.all(eventsPromises)).flat();
    let liquidityChangeEvents = events.map((e) => {
        return e;
    });
    if (params.poolNames) {
        liquidityChangeEvents = liquidityChangeEvents.filter((e) => params.poolNames.includes(maps_js_1.poolIdPoolNameMap[e.pool_id]));
    }
    return liquidityChangeEvents;
}
//# sourceMappingURL=fetchLiquidityChangeEvents.js.map